export default __webpack_public_path__ + "static/media/escoffier_edu_card_image.3bc04b1d.png";